import { Fragment } from 'react';

/**
 * A question's words with each `https://` address in them drawn as a link, opened in a new tab
 * (the survey review's T27: the attestations name the user agreement by its address). Display
 * only — the words are survey-api's, and nothing here judges an address: a run of non-space
 * characters after `https://` is the address, less a sentence's closing punctuation. `http://`
 * and a bare `www.` stay text, as authored.
 */
export function LinkedText({ text }: { text: string }) {
  const parts = text.split(/(https:\/\/\S+)/);
  if (parts.length === 1) return <>{text}</>;
  return (
    <>
      {parts.map((part, index) => {
        if (index % 2 === 0) return <Fragment key={index}>{part}</Fragment>;
        const [, address, after] = /^(.*?)([.,;:!?)]*)$/.exec(part) ?? [part, part, ''];
        return (
          <Fragment key={index}>
            <a
              href={address}
              target="_blank"
              rel="noopener noreferrer"
              className="break-all text-[var(--color-sapphire)] underline underline-offset-2"
            >
              {address}
            </a>
            {after}
          </Fragment>
        );
      })}
    </>
  );
}
